export interface AuthorizationData {
    sid: string;
    expire_time: number;
    create_time: number;
}

export interface RegisterData {
    title_id?: number;
    first_name: string;
    last_name: string;
    phone: string;
    email: string;
    password: string;
    referrer_code: string;
    birth_date_formatted: string;
    type_id: number;
    preferences: {
        allow_mk_all?: boolean;
        allow_mk_push_notification?: boolean;
        allow_mk_sms?: boolean;
        allow_mk_email?: boolean;
        allow_mk_call?: boolean;
        allow_mk_letter?: boolean;
    };
}

export function isRegisterData(obj: any): obj is RegisterData {
    return (
        'type_id' in obj &&
        'first_name' in obj &&
        'last_name' in obj &&
        'phone' in obj &&
        'email' in obj &&
        'password' in obj
    );
}

export interface RequestResetPasswordData {
    email: string;
}

export interface RequestClaimAccountData {
    email: string;
}

export interface ClaimAccountData {
    type_id: number;
    password: string;
    register_token: string;
}

export function isClaimAccountData(obj: any): obj is ClaimAccountData {
    return 'type_id' in obj && 'password' in obj && 'register_token' in obj;
}

export interface ResetPasswordData {
    token: string;
    password: string;
    confirm_password: string;
}

export interface LoginWithTokenData {
    auto_login_token: string;
}

export function isLoginWithTokenData(obj: any): obj is LoginWithTokenData {
    return 'auto_login_token' in obj;
}

export interface LoginData {
    username: string;
    password: string;
}

export function isLoginData(obj: any): obj is LoginData {
    return 'username' in obj && 'password' in obj;
}

export interface SessionResponseData {
    session: AuthorizationData;
}

export interface SocialProvider {
    id: number;
    type: string;
    name: string;
    data: SocialConfig;
    sort: number;
}

export interface SocialConfig {
    app_id?: number;
    client_id?: string;
    tenant?: string;
    policy?: string;
}
